<template>
  <div class="row">
    <QInput v-if="!hideSearch" outlined class="col-12" :color="color" v-model="filterText" :label="label" :disabled="disabled" />
    <div class="row col-12" style="flex-wrap: wrap">
      <QCheckbox
        v-for="(option, index) in filteredOptions"
        :key="option.id"
        :class="getCheckboxClassname(index, false)"
        :color="color"
        v-model="selectedOptions[option.value]"
        :label="option.label"
        :disable="disabled"
        @input="handleInput"
      />
      <QCheckbox
        v-if="filteredOptions && filteredOptions.length > 1"
        :class="getCheckboxClassname(filteredOptions.length, true)"
        :color="color"
        v-model="selectAll"
        label="Select all"
        :disable="disabled"
        @input="selectAllOptions"
      />
    </div>
  </div>
</template>

<script>
import { QInput, QCheckbox } from 'quasar';

export default {
  name: 'RefineSearchMultiCheckbox',
  props: {
    label: {
      type: String,
      default: 'Search'
    },
    hideSearch: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'secondary'
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value) && value.every((opt) => 'id' in opt && 'label' && 'value' in opt)
    },
    value: {
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    /** Two columns (col-6) on narrow viewports; use for embedded mobile make list. */
    twoColumnsMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterText: '',
      selectedOptions: this.value,
      selectAll: false
    };
  },
  computed: {
    filteredOptions() {
      const filterLowerCase = this.filterText.toLowerCase();

      return this.options.filter((option) => option.label.toLowerCase().startsWith(filterLowerCase));
    }
  },
  methods: {
    getCheckboxClassname(index, isSelectAllRow) {
      if (this.dense && this.twoColumnsMobile) {
        return isSelectAllRow ? 'col-12' : 'col-6 col-sm-4 col-md-3';
      }

      if (this.dense) {
        return 'col-12 col-sm-4 col-md-3';
      }

      if (this.twoColumnsMobile) {
        return isSelectAllRow ? 'col-12' : 'col-6';
      }

      return Boolean(index % 2) ? 'col-12 col-sm-6 col-shrink' : 'col-12 col-sm-6 col-md-6';
    },
    handleInput() {
      const allOptionsSelected = this.filteredOptions.every((option) => this.selectedOptions[option.value]);
      this.selectAll = allOptionsSelected;
      const payload = { ...this.selectedOptions };
      this.$emit('input', payload);
      this.$emit('change', payload);
    },
    selectAllOptions() {
      this.filteredOptions.forEach((option) => {
        this.$set(this.selectedOptions, option.value, this.selectAll);
      });
      this.handleInput();
    }
  },
  created() {
    this.selectAll = this.filteredOptions.every((option) => this.selectedOptions[option.value]);
  },
  watch: {
    value(newValue) {
      this.selectedOptions = newValue;
    }
  },
  components: { QInput, QCheckbox }
};
</script>

<style lang="sass" scoped></style>
